// extracted by mini-css-extract-plugin
export var width100 = "D_s d_s";
export var design3Pos = "D_tg d_X";